import { NimblaWelcome } from './NimblaWelcome';

export default NimblaWelcome;
